// Locations API service
import { apiService } from './api';
import {
  Location,
  LocationCreate,
  LocationUpdate,
  LocationFilters
} from '../types';

export class LocationsService {
  async convertLocationAssets(facilityId: string): Promise<{ converted: number; deleted: number; skipped: { id: string; name: string; reason: string }[] }> {
    return apiService.post(`/facilities/${facilityId}/convert-location-assets`, {});
  }

  async getLocations(params?: LocationFilters): Promise<Location[]> {
    return apiService.get<Location[]>('/locations/', params);
  }

  async getLocationById(id: string): Promise<Location> {
    return apiService.get<Location>(`/locations/${id}`);
  }

  async createLocation(locationData: LocationCreate): Promise<Location> {
    return apiService.post<Location>('/locations/', locationData);
  }

  async updateLocation(id: string, locationData: LocationUpdate): Promise<Location> {
    return apiService.put<Location>(`/locations/${id}`, locationData);
  }

  async deleteLocation(id: string): Promise<void> {
    return apiService.delete<void>(`/locations/${id}`);
  }

  async getFacilityLocations(facilityId: string, params?: LocationFilters): Promise<Location[]> {
    const rows: Location[] = [];
    let page: Location[];
    do {
      page = await this.getLocations({ ...params, facility_id: facilityId, skip: rows.length, limit: 1000 });
      rows.push(...page);
    } while (page.length === 1000);
    return rows;
  }
}

export const locationsService = new LocationsService();
